import { Checkbox } from "@material-ui/core";
import Jumbotron from "components/Jumbotron";
import { contactUs } from "features/admin/EmailSender/emailSenderSlice";
import { ErrorMessage, SubmitButton } from "features/payment/paymentPageStyles";
import React, { useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import styled from "styled-components/macro";
import { device, toRem } from "theme/Breakpoints";
import { DefaultText, SectionSubTitle, shadow } from "theme/GlobalElements";
import { colors } from "theme/Theme";
import { Link } from "react-router-dom";

interface MessageUsProps {}

const MessageUs: React.FC<MessageUsProps> = ({}) => {
  const { register, control, handleSubmit, errors, reset } = useForm();

  const dispatch = useDispatch();
  const onFormSubmit = async (data: any) => {
    if (!data.emailFake) {
      dispatch(contactUs(data));
      reset();
    }
  };

  return (
    <Jumbotron>
      <MessageUsTitle>
        <h3>
          Изпратете ни съобщение
          <p className="caption">свържете се с нас чрез съобщение</p>
        </h3>
      </MessageUsTitle>
      {errors.names && errors.names?.type === "required" && (
        <ErrorMessage>Полето е задължително</ErrorMessage>
      )}

      {errors.email && errors.email?.type === "pattern" && (
        <ErrorMessage>
          Имейл адресът трябва да е в следния формат johndoe@gmail.com
        </ErrorMessage>
      )}

      {errors.number && errors.number?.type === "minLength" && (
        <ErrorMessage>Дължината трябва да 10 символа.</ErrorMessage>
      )}
      <InputContainer onSubmit={handleSubmit(onFormSubmit)}>
        <Inputs>
          <Input
            className="text-body"
            name="names"
            ref={register({ required: true })}
            placeholder="* Имена"
            required={true}
          />
          <Input
            className="text-body"
            name="email"
            ref={register({
              required: true,
              pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
            })}
            placeholder="* Имейл адрес"
          />
          <Input
            className="text-body"
            name="number"
            ref={register({ minLength: 5, maxLength: 20 })}
            placeholder="* Телефонен номер"
            required={true}
          />
          <Input
            className="text-body"
            name="emailFake"
            style={{ display: "none" }}
          />
        </Inputs>
        {errors.message && errors.message?.type === "minLength" && (
          <ErrorMessage>Дължината трябва да бъде поне 10 символа.</ErrorMessage>
        )}
        {errors.message && errors.message?.type === "maxLength" && (
          <ErrorMessage>
            Максималната дължина на съобщението е 300 символа.
          </ErrorMessage>
        )}
        <TextAreaInput
          className="text-body"
          name="message"
          ref={register({ minLength: 10, maxLength: 300 })}
          placeholder="* Съобщение"
          required={true}
        />
        {errors.consentCheckbox &&
          errors.consentCheckbox?.type === "required" && (
            <ErrorMessage>
              Съгласието с нашата политика за обработване на личните данни е
              задължително.
            </ErrorMessage>
          )}
        <ConsentCheckbox>
          <Controller
            name="consentCheckbox"
            control={control}
            defaultValue={false}
            rules={{ required: true }}
            render={(props) => (
              <>
                <Checkbox
                  onChange={(e) => props.onChange(e.target.checked)}
                  checked={props.value}
                />
              </>
            )} // props contains: onChange, onBlur and value
          />
          <ConsentText className="text-sm">
            С изпращането на тази форма Вие се съгласявате личните Ви данни да
            бъдат обработвани в съответствие с{" "}
            <NavLink to={"/terms-and-conditions"}>
              Политика за обработване на личните данни
            </NavLink>
          </ConsentText>
        </ConsentCheckbox>

        <ConsentCheckbox>
          <Controller
            name="isSubscribed"
            control={control}
            defaultValue={false}
            // rules={{ required: true }}
            render={(props) => (
              <>
                <Checkbox
                  onChange={(e) => props.onChange(e.target.checked)}
                  checked={props.value}
                />
              </>
            )} // props contains: onChange, onBlur and value
          />

          <ConsentText className="text-sm">
            * Абонирайте се за промоционални оферти
          </ConsentText>
        </ConsentCheckbox>

        <SubmitButton
          className="submit-button text-md"
          type="submit"
          value="Изпрати"
        />
      </InputContainer>
    </Jumbotron>
  );
};

const NavLink = styled(Link)``;

const MessageUsTitle = styled.div``;
MessageUsTitle.displayName = "MessageUsTitle";

const InputContainer = styled.form`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  width: 100%;

  .submit-button {
    border-radius: 5px;

    @media only screen and (${device.laptopL}) {
      width: 33%;
    }
  }
`;
InputContainer.displayName = "InputContainer";

const Inputs = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media only screen and (${device.laptop}) {
    flex-flow: row;
    justify-content: space-between;
  }
`;
Inputs.displayName = "Inputs";

export const Input = styled.input`
  font-size: 16px;
  flex: 1 100%;
  background-color: white;
  border-radius: 5px;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid ${colors.dark_gray};

  & + & {
    margin-top: 12px;
  }

  @media only screen and (${device.laptop}) {
    flex: 0 32%;

    & + & {
      margin-top: 0;
    }
  }

  @media only screen and (${device.laptopL}) {
    flex: 0 33%;
  }
`;
Input.displayName = "Input";

const TextAreaInput = styled.textarea`
  flex: 1 100%;
  max-width: 100%;
  min-width: 100%;
  height: 150px;
  min-height: 150px;
  background-color: white;
  border-radius: 5px;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid ${colors.dark_gray};
  margin-top: 12px;
`;
TextAreaInput.displayName = "TextAreaInput";

const ConsentCheckbox = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin: 12px 0;
`;
ConsentCheckbox.displayName = "ConsentCheckbox";

const ConsentText = styled(DefaultText)`
  color: ${colors.darkest_gray};
  flex: 1;

  .PrivateSwitchBase-root-1 {
    padding: 0;
  }

  a {
    color: ${colors.light_blue};
  }
`;
ConsentText.displayName = "ConsentText";

export default MessageUs;
